<template>
  <div v-if="!isDeluxeLayout">
     <BreadcrumbsProject
        :breadcrumbs="[
            {
                link : dotnetUrl +'/project/list',
                title : 'Projects',
                isRouterLink: false
            },
            {
                link : projectUrl +'/Project/' + projectInfo._id,
                title : (projectInfo.projectNumber || '-') +' ' + (projectInfo.projectName || ''),
                isRouterLink: false
            },
            {
                link : '/boq/' + projectInfo._id,
                title : 'Bill of Quantities',
                isRouterLink: true
            },
            {
                link : '/boq/items/' + boqItemData._id,
                title :(boqItemData.name || '-')  + ' - (' + (boqItemData.currencyId?.sign || '') +') '  + ( boqItemData.currencyId?.shortName || '')  +' '+ (boqItemData.currencyId?.name || ''),
                isRouterLink: true
            }
        ]"
    ></BreadcrumbsProject>
  </div>
  <div class="boq-items-navigation">
    <StepItem2 :active-index="isDeluxeLayout ? 1 : null" :deluxe="isDeluxeLayout" />
    <div v-if="isDeluxeLayout" class="deluxe-project-back">
      <router-link :to="{ name: 'Boq', params: { id: boqItemData.projectId || projectInfo._id } }">
        <i class="fa-solid fa-chevron-left"></i> Back to Bill of Quantity
      </router-link>
    </div>
  </div>
  <div class="row mt-1 pb-2 boq-items-workflow" v-if="boqItemData.approvalStage==ApprovalStageBoq.FOR_APPROVAL">
    <BoqProcessWorkFlow
      v-if="processItemData._id"
      :processItemData="processItemData" 
      :showApprovalDisapprove="false"
      :showGoToApproval="true"
    />
  </div>

  <div class="boq-items-page">
    <div class="card boq-items-card">
      <div class="card-header boq-items-card__header">
        <div class="boq-items-hero">
          <div class="boq-items-heading">
            <span class="boq-items-eyebrow">Bill of Quantities</span>
            <h1>{{ boqItemData.name || '-' }}</h1>
            <p>
              <span>{{ projectInfo.projectNumber || '-' }} {{ projectInfo.projectName || '' }}</span>
              <span v-if="currencyLabel" class="boq-items-heading__divider"></span>
              <span v-if="currencyLabel">{{ currencyLabel }}</span>
            </p>
            <router-link
              v-if="boqItemData.reference"
              :to="{name : 'BoqQuotation', params : {id : boqItemData.reference._id} }"
              class="boq-items-reference"
            >
              <i class="fa-solid fa-link"></i>
              {{boqItemData.reference.quotationNumber}} {{boqItemData.reference.quotationName}}
            </router-link>
          </div>
          <div class="boq-items-hero__side">
            <span class="boq-items-status">
              {{ApprovalStageBoqObj[boqItemData.approvalStage-1].name}}
            </span>
            <div class="boq-items-primary-actions">
              <button
                class="btn boq-items-action boq-items-action--primary"
                @click="OpenAddItemModal"
                data-bs-toggle="modal"
                data-bs-target="#ModalNewLineItem"
                v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"
              ><i class="fa-solid fa-plus"></i> Add Line Item</button>
              <button
                class="btn boq-items-action boq-items-action--approval"
                v-if="boqItemData.approvalStage !=ApprovalStageBoq.FOR_APPROVAL && permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"
                @click="SendForNewWorkFlow"
              ><i class="fa-solid fa-file-pen"></i> Send For Approval</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body boq-items-card__body">
        <div class="boq-items-published" role="alert" v-if="boqItemData.approvalStage==ApprovalStageBoq.PUBLISHED">
          <span class="boq-items-published__icon"><i class="fa-solid fa-file-circle-check"></i></span>
          <div>
            <strong>Published BoQ</strong>
            <span>Last published on {{ReformatDate(boqItemData.publishedDate)}} by <b class="text-capitalize">{{boqItemData.publishedBy.fullname}}</b></span>
          </div>
        </div>
        <div class="boq-items-toolbar">
          <div class="boq-items-toolbar__group">
            <button
              :class="['btn boq-items-tool', { 'is-active': OpenFilter }]"
              @click="()=>{ OpenFilter = !OpenFilter}"
              :title="$t('Filter Line Items')"
            ><i class="fa-solid fa-filter"></i><span>Filters</span></button>
            <button class="btn boq-items-tool" :title="$t('Filter Columns')" data-bs-toggle="modal" data-bs-target="#BoqColumnFilter">
              <i class="fa-solid fa-table-columns"></i><span>Columns</span>
            </button>
          </div>
          <div class="boq-items-view-links">
            <router-link :to="{name : 'BoqItemsPreview', params : {id : boqItemData._id} }"><i class="fa-regular fa-eye"></i> Preview</router-link>
            <router-link :to="{name : 'BoqItemsSummary', params : {id : boqItemData._id} }"><i class="fa-solid fa-chart-pie"></i> Summary</router-link>
          </div>
          <div class="boq-items-toolbar__group boq-items-toolbar__group--right">
            <button
              class="btn boq-items-tool"
              data-bs-toggle="modal"
              data-bs-target="#ModalImportBoq"
              v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"
              @click="OpenImportModal"
              :title="$t('Import File')"
            ><i class="fa-solid fa-upload"></i><span>Import</span></button>
            <button
              class="btn boq-items-tool"
              :title="$t('Export to File')"
              data-bs-toggle="modal"
              data-bs-target="#BoqExportBoqList"
              @click="()=>{ exportTemplateType= 0; exportTemplateFilter = null}"
            ><i class="fa-solid fa-file-arrow-down"></i><span>Export</span></button>
            <router-link :title="$t('Print Bill of Quantity')" :to="{name : 'BoqItemsPrint', params : {id : boqItemData._id} }" class="btn boq-items-tool">
              <i class="fa-solid fa-print"></i><span>Print</span>
            </router-link>
          </div>
        </div>
        <div class="row boq-items-content">
          <div class="col-md-6 pb-2 boq-items-filter" v-if="OpenFilter">
            <div class="form-group ">
              <label class="d-flex justify-content-between">
                  <a>Cost Category</a>
                  <span role="button" class="text-danger text-decoration-underline" @click="ClearField(2)"><i class="fa-solid fa-xmark "></i> Clear Field</span>
              </label>
              <Multiselect 
              :multiple="true" :options="dataCostCodes" 
              :internalSearch="false"
              placeholder="Type Here to search by Cost Category"
              v-model="selectedCostCode"  @search-change="SearchCostCodeAll" :searchable="true" :loading="searchCostCodeLoading"
              :clear-on-select="false" :max-height="300"
              label="costName" track-by="_id"/>
            </div>
          </div>
          <div class="col-md-6 pb-2 boq-items-filter" v-if="OpenFilter">
            <div class="form-group ">
              <label class="d-flex justify-content-between">
                  <a>Space ID</a>
                  <span role="button" class="text-danger text-decoration-underline" @click="ClearField(1)"><i class="fa-solid fa-xmark "></i> Clear Field</span>
              </label>
              <Multiselect 
              :multiple="true" :options="areaList" 
              placeholder="Type Here to search by Space ID"
              v-model="selectedArea"  :max-height="300" />
            </div>
          </div>
          <div class="col-md-12 boq-items-table-shell">

            <Loader v-if="tableLoading" />
            <div v-else-if="dataReady">
              <BoqItemTable  :rowDatas="rowDatas" :reloadData="ReloadList" :stage="boqItemData.approvalStage"  :OpenEditModal="OpenEditLineItem"
              :measurementUnits="measurementUnits" :selectedColumns="selectedColumns" :updateSelected="UpdateSelected" :BoqCategoryList="BoqCategoryList" :GetChanges="GetChanges" />
            </div>

          </div>
        </div>
        
       
      </div>
      
    </div>
  </div>
  <Modal idModal="BoqReviewModal" headerTitle="Send For Review BoQ" v-if="permission.indexOf(ModuleActionList.BOQ_PUBLISH) >-1">
    <div>
       <div class="form-group">
            <label class="required-style">Date End </label>
            <input type="date" v-model="boqPublishData.dateEnd" class="form-control"/> 
            <small class="text-warning" v-if="isPublishClicked && !boqPublishData.dateEnd">Required</small>
        </div>
       <div class="form-group">
            <label class="required-style">Process </label>
            <Select2
                :dataOptions="reviewProcessList"
                indexValue="_id"
                labelName="processName"
                placeHolder="Search Process Here"
                v-model:optionValue="boqPublishData.processId"
                ref="selectCostCode"
            >
            </Select2>
            <a class="text-primary small"  :href="projectUrl +'/Project/' + projectInfo._id+'/process'">No Process on the list? Click here to Create</a>
            <small class="text-warning" v-if="isPublishClicked && !boqPublishData.processId">Required</small>
        </div>
    </div>
    <template v-slot:actions>
      <button type="button" ref="closeBoqPublishModal" class="btn btn-outline-danger" data-bs-dismiss="modal">X Cancel</button>
      <button type="button" class="btn btn-primary"  @click="ReviewBoqRun"><i class="fas fa-save"></i> Send for Review</button>
    </template>
  </Modal>
  <Modal idModal="BoqApprovalModal" headerTitle="Send For Approval BoQ" v-if="permission.indexOf(ModuleActionList.BOQ_PUBLISH) >-1">
      <div>
       <div class="form-group">
            <label class="required-style">Date End </label>
            <input type="date" v-model="boqApprovalData.dateEnd" class="form-control"/> 
            <small class="text-warning" v-if="isApprovalClicked && !boqApprovalData.dateEnd">Required</small>
        </div>
       <div class="form-group">
            <label class="required-style">Process </label>
            <Select2
                :dataOptions="approvalProcessList"
                indexValue="_id"
                labelName="processName"
                placeHolder="Search Process Here"
                v-model:optionValue="boqApprovalData.processId"
                
            >
            </Select2>
            <a class="text-primary small"  :href="projectUrl +'/Project/' + projectInfo._id+'/process'">No Process on the list? Click here to Create</a>
            <small class="text-warning" v-if="isApprovalClicked && !boqApprovalData.processId">Required</small>
        </div>
      </div>
      <template v-slot:actions>
        <button type="button" ref="closeBoqApprovalModal" class="btn btn-outline-danger" data-bs-dismiss="modal">X Cancel</button>
        <button type="button" class="btn btn-primary"  @click="ForApprovalBoqRun"><i class="fas fa-save"></i> Send for Approval</button>
      </template>
  </Modal>
  <Modal idModal="BoqExportBoqList" headerTitle="Export BoQ"  >
      <div>
          <div class="form-group">
              <label class="required-style">Template </label>
              <select class="form-select" v-model="exportTemplateType"> 
                  <option v-for="(item,key) in ExportTemplatesForExport" :key="key" :value="key">{{item}}</option>
              </select>
          </div>
          <!-- <div class="form-group">
              <label >Filter </label>
              <Multiselect 
              :options="dataCostCodes" 
              placeholder="Type Here to search by Cost Category"
              v-model="exportTemplateFilter"  @search-change="SearchCostCodeAll" :searchable="true" 
              :internalSearch="false" :loading="searchCostCodeLoading"
              :clear-on-select="false" :max-height="300"
              label="costName" track-by="_id"/>
          </div> -->
      </div>
      <template v-slot:actions>
          <div>
              <!-- <button type="button" class="btn btn-outline-primary" @click="ExportForClient" >
                  <i class="fa-solid fa-user-tie"></i>  Export for Client
              </button> -->
          </div>
          <button type="button" class="btn btn-primary" @click="ExportBoqList" >
              <i class="fa-solid fa-file-arrow-down"></i>  Export
          </button>
      </template>
  </Modal>
  <Modal idModal="BoqGroupList" headerTitle="Select Line Item Parent"  v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"  >
      <div>
          <div class="" v-for="(item,key) in selectedLineItems" :key="key">
            <input type="radio" :id="key + '-radio'" :value="item._id" v-model="selectedParent" />
            <label class="ps-3 h6 fw-normal" :for="key + '-radio'">{{item.costCode}} {{item.name}}</label>
          </div>
          
      </div>
      <template v-slot:actions>
          <div>
              
          </div>
          <button type="button" class="btn btn-primary"  >
              <i class="fas fa-save"></i> Group
          </button>
      </template>
  </Modal>
  <ModalLineItemColumnFilter :UpdateSelectedColumn="ChangeSelectecColumnValue"/>

  <ModalNewLineItem
  v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"
  ref="modalNewLineItem"
  :boqList="boqList" :ResetData="GetDataList" :boqId="boqItemData._id" />

  <ModalImportLineItems
  
  v-if="boqItemData.projectId && permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"
  ref="modalImportLineItem"
  :boqList="boqList" :ResetData="GetDataList" :boqId="boqItemData._id" :projectId="boqItemData.projectId" />

  <ModalUpdateLineItem
  v-if="permission.indexOf(ModuleActionList.BOQ_EDIT) >-1"
  :selectedLineItem="updateLineItem"
  :boqList="boqList" :ResetData="GetDataList" />
</template>

<script src="@/assets/boq/BoqItems.js" />

<style>
.deluxe-layout.theme-boq .boq-items-navigation {
  width: 100%;
  max-width: 96rem;
  margin-right: auto;
  margin-left: auto;
}

.deluxe-layout.theme-boq .boq-items-page,
.deluxe-layout.theme-boq .boq-items-workflow {
  width: 100%;
  max-width: 96rem;
  margin-right: auto;
  margin-left: auto;
}

.deluxe-layout.theme-boq .boq-items-card {
  overflow: hidden;
  border: 1px solid #eadfce;
  border-radius: 0.4rem;
  background: #ffffff;
  box-shadow: 0 1.1rem 2.8rem rgba(42, 32, 22, 0.08);
}

.deluxe-layout.theme-boq .boq-items-card__header {
  border-bottom: 1px solid #eadfce;
  padding: 1.15rem 1.25rem;
  background: #ffffff;
}

.deluxe-layout.theme-boq .boq-items-hero {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1.5rem;
}

.deluxe-layout.theme-boq .boq-items-heading {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 0.22rem;
}

.deluxe-layout.theme-boq .boq-items-eyebrow {
  color: var(--lens-accent-dark);
  font-size: 0.72rem;
  font-weight: 850;
  line-height: 1.2;
}

.deluxe-layout.theme-boq .boq-items-heading h1 {
  overflow: hidden;
  margin: 0;
  color: #1e1b16;
  font-size: 1.55rem;
  font-weight: 850;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.deluxe-layout.theme-boq .boq-items-heading p {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin: 0;
  color: #746a61;
  font-size: 0.8rem;
  font-weight: 650;
}

.deluxe-layout.theme-boq .boq-items-heading__divider {
  width: 0.22rem;
  height: 0.22rem;
  border-radius: 999px;
  background: #b7aba1;
}

.deluxe-layout.theme-boq .boq-items-reference {
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 0.35rem;
  color: #21356f;
  font-size: 0.76rem;
  font-weight: 750;
  text-decoration: none;
}

.deluxe-layout.theme-boq .boq-items-reference:hover {
  color: var(--lens-accent-dark);
}

.deluxe-layout.theme-boq .boq-items-hero__side {
  display: flex;
  flex: 0 0 auto;
  align-items: flex-end;
  flex-direction: column;
  gap: 0.7rem;
}

.deluxe-layout.theme-boq .boq-items-status {
  display: inline-flex;
  min-height: 1.65rem;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 0.3rem 0.78rem;
  color: #9b4c00;
  background: #ffe9b0;
  font-size: 0.68rem;
  font-weight: 850;
  line-height: 1;
  text-transform: uppercase;
}

.deluxe-layout.theme-boq .boq-items-primary-actions,
.deluxe-layout.theme-boq .boq-items-toolbar__group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.42rem;
}

.deluxe-layout.theme-boq .boq-items-action,
.deluxe-layout.theme-boq .boq-items-tool {
  display: inline-flex;
  min-height: 2.3rem;
  align-items: center;
  justify-content: center;
  gap: 0.42rem;
  border-radius: 0.28rem !important;
  padding: 0 0.85rem;
  font-size: 0.78rem;
  font-weight: 800;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  box-shadow: none !important;
}

.deluxe-layout.theme-boq .boq-items-action--primary {
  border: 1px solid var(--lens-accent-dark) !important;
  color: #ffffff !important;
  background: var(--lens-accent-dark) !important;
}

.deluxe-layout.theme-boq .boq-items-action--approval {
  border: 1px solid #21356f !important;
  color: #ffffff !important;
  background: #21356f !important;
}

.deluxe-layout.theme-boq .boq-items-action:hover,
.deluxe-layout.theme-boq .boq-items-action:focus {
  opacity: 0.88;
}

.deluxe-layout.theme-boq .boq-items-card__body {
  padding: 1rem 1.25rem 1.35rem;
}

.deluxe-layout.theme-boq .boq-items-published {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
  border: 1px solid #cde8da;
  border-left: 3px solid #249277;
  border-radius: 0.28rem;
  padding: 0.75rem 0.9rem;
  color: #1e1b16;
  background: #f2fbf7;
}

.deluxe-layout.theme-boq .boq-items-published__icon {
  display: inline-flex;
  width: 2.15rem;
  height: 2.15rem;
  flex: 0 0 2.15rem;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: #249277;
  background: #d8eee5;
}

.deluxe-layout.theme-boq .boq-items-published strong,
.deluxe-layout.theme-boq .boq-items-published span {
  display: block;
}

.deluxe-layout.theme-boq .boq-items-published strong {
  font-size: 0.82rem;
  font-weight: 850;
}

.deluxe-layout.theme-boq .boq-items-published div > span {
  margin-top: 0.1rem;
  color: #5e6b64;
  font-size: 0.75rem;
}

.deluxe-layout.theme-boq .boq-items-toolbar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.9rem;
  border: 1px solid #eee4da;
  border-radius: 0.32rem;
  padding: 0.55rem;
  background: #fffaf7;
}

.deluxe-layout.theme-boq .boq-items-toolbar__group--right {
  justify-content: flex-end;
}

.deluxe-layout.theme-boq .boq-items-tool {
  min-height: 2.15rem;
  border: 1px solid #dfd5c9 !important;
  color: #5f564d !important;
  background: #ffffff !important;
}

.deluxe-layout.theme-boq .boq-items-tool:hover,
.deluxe-layout.theme-boq .boq-items-tool:focus,
.deluxe-layout.theme-boq .boq-items-tool.is-active {
  border-color: #e7c1a8 !important;
  color: var(--lens-accent-dark) !important;
  background: var(--lens-table-header) !important;
}

.deluxe-layout.theme-boq .boq-items-view-links {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.95rem;
}

.deluxe-layout.theme-boq .boq-items-view-links a {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #21356f;
  font-size: 0.76rem;
  font-weight: 800;
  text-decoration: none;
}

.deluxe-layout.theme-boq .boq-items-view-links a:hover {
  color: var(--lens-accent-dark);
}

.deluxe-layout.theme-boq .boq-items-content {
  margin: 0;
}

.deluxe-layout.theme-boq .boq-items-filter {
  margin-bottom: 0.8rem;
  border: 1px solid #eee4da;
  padding: 0.85rem !important;
  background: #fffdfb;
}

.deluxe-layout.theme-boq .boq-items-filter label {
  margin-bottom: 0.38rem;
  color: #1e1b16;
  font-size: 0.76rem;
  font-weight: 800;
}

.deluxe-layout.theme-boq .boq-items-filter label a {
  color: #1e1b16;
  text-decoration: none;
}

.deluxe-layout.theme-boq .boq-items-filter label span {
  color: #b64822 !important;
  font-size: 0.7rem;
}

.deluxe-layout.theme-boq .boq-items-table-shell {
  padding: 0;
}

.deluxe-layout.theme-boq .boq-items-table-shell .table-responsive {
  overflow: auto;
  height: min(68vh, 46rem) !important;
  border: 1px solid #eadfce;
  border-radius: 0.34rem;
  background: #ffffff;
}

.deluxe-layout.theme-boq .boq-items-table-shell .table {
  margin: 0;
  border: 0;
  color: #1e1b16 !important;
  font-size: 0.78rem !important;
}

.deluxe-layout.theme-boq .boq-items-table-shell .table > thead > tr > th {
  border-color: #e7cdbd !important;
  border-top: 0;
  padding: 0.72rem 0.7rem;
  color: var(--lens-accent-dark) !important;
  background: var(--lens-table-header) !important;
  font-size: 0.7rem;
  font-weight: 850;
  line-height: 1.25;
  vertical-align: middle;
}

.deluxe-layout.theme-boq .boq-items-table-shell .table > tbody > tr > td {
  border-color: #eee6de;
  padding: 0.68rem 0.7rem;
  color: #2b2723;
  background: #ffffff;
  vertical-align: middle;
}

.deluxe-layout.theme-boq .boq-items-table-shell .table > tbody > tr:nth-child(even) > td {
  background: #fdf9f6;
}

.deluxe-layout.theme-boq .boq-items-table-shell .table > tbody > tr:hover > td {
  background: #fff4ed;
}

.deluxe-layout.theme-boq .boq-items-table-shell .table .bg-light-primary {
  color: #7d3d18 !important;
  background: #f5e2d5 !important;
}

.deluxe-layout.theme-boq .boq-items-table-shell .table .sticky-left,
.deluxe-layout.theme-boq .boq-items-table-shell .table .sticky-right {
  box-shadow: 0.35rem 0 0.8rem rgba(42, 32, 22, 0.04);
}

.deluxe-layout.theme-boq .boq-items-table-shell .table .btn-action {
  width: 1.85rem;
  height: 1.85rem;
  border-radius: 0.22rem;
  padding: 0;
  background: #ffffff;
}

.deluxe-layout.theme-boq.dark .boq-items-card,
.deluxe-layout.theme-boq.dark .boq-items-card__header,
.deluxe-layout.theme-boq.dark .boq-items-card__body,
.deluxe-layout.theme-boq.dark .boq-items-filter,
.deluxe-layout.theme-boq.dark .boq-items-table-shell .table-responsive {
  border-color: #3b4542;
  background: #222927;
}

.deluxe-layout.theme-boq.dark .boq-items-heading h1,
.deluxe-layout.theme-boq.dark .boq-items-filter label,
.deluxe-layout.theme-boq.dark .boq-items-filter label a {
  color: #ffffff;
}

.deluxe-layout.theme-boq.dark .boq-items-heading p {
  color: #b9c0bd;
}

.deluxe-layout.theme-boq.dark .boq-items-toolbar {
  border-color: #44403c;
  background: #2c2926;
}

.deluxe-layout.theme-boq.dark .boq-items-tool {
  border-color: #55504a !important;
  color: #e8e3de !important;
  background: #342f2b !important;
}

@media (max-width: 991.98px) {
  .deluxe-layout.theme-boq .boq-items-hero {
    flex-direction: column;
  }

  .deluxe-layout.theme-boq .boq-items-hero__side {
    width: 100%;
    align-items: flex-start;
  }

  .deluxe-layout.theme-boq .boq-items-toolbar {
    grid-template-columns: 1fr;
  }

  .deluxe-layout.theme-boq .boq-items-view-links {
    justify-content: flex-start;
  }

  .deluxe-layout.theme-boq .boq-items-toolbar__group--right {
    justify-content: flex-start;
  }
}

@media (max-width: 575.98px) {
  .deluxe-layout.theme-boq .boq-items-heading h1 {
    font-size: 1.25rem;
  }

  .deluxe-layout.theme-boq .boq-items-primary-actions,
  .deluxe-layout.theme-boq .boq-items-primary-actions .boq-items-action {
    width: 100%;
  }

  .deluxe-layout.theme-boq .boq-items-tool span {
    display: none;
  }
}
</style>
